import TreatmentFullLayout from "../../components/TreatmentLayout";
import Service11 from "../../assets/images/service/11.jpg"; 

import ImgPediatric from "../../assets/images/service_detail/pediatric/01.jpg";
import ImgCircum from "../../assets/images/service_detail/pediatric/02.jpeg";
import ImgHypo from "../../assets/images/service_detail/pediatric/03.jpg";
import ImgPUJO from "../../assets/images/service_detail/pediatric/04.png";
import ImgVUR from "../../assets/images/service_detail/pediatric/05.jpg";

const PediatricUrology = () => {

const data = {
title:"Pediatric Urology Treatment in Bhilwara",
subtitle:"Best Child Urology Specialist Dr Sachitanand Chaurasia at BBMH Hospital",

heading:"Best Pediatric Urologist in Bhilwara",
description:"Pediatric urology focuses on urinary and genital problems in children. At BBMH Hospital Bhilwara, specialized treatment for children's urological conditions ensures safe and effective care with advanced technology.",

image:Service11,

sections:[

{
title:"What is Pediatric Urology?",
content:"Pediatric urology is a specialized branch of urology that focuses on urinary and genital problems in children from birth to adolescence. These problems may be congenital (present from birth) or develop during childhood. At BBMH (Brijesh Banger Memorial Hospital), Dr. Sachitanand Chaurasia provides advanced pediatric urology care with child-friendly approach, modern technology and safe surgical treatment.",
image: ImgPediatric
},

{
title:"Common Pediatric Urology Problems",
content:"Children may suffer from various urological disorders. Below are common conditions with brief explanation:",
list:[
"Phimosis – Tight foreskin that cannot be pulled back properly causing pain, infection or difficulty in urination.",
"Hypospadias – A birth condition where urine opening is not at normal position on the tip of penis.",
"PUJO (Pelviureteric Junction Obstruction) – Blockage at kidney junction causing kidney swelling (hydronephrosis).",
"VUR (Vesicoureteric Reflux) – Backward flow of urine from bladder to kidney leading to repeated infections.",
"Undescended Testis (UDT) – Testicle does not move into scrotum after birth and may require surgery.",
"Hydrocele – Fluid collection around testicle causing painless swelling in scrotum.",
"Urinary Tract Infection (UTI) – Infection in bladder or kidney causing burning urination and fever.",
"Learned Voiding Dysfunction – Improper bladder emptying due to wrong urination habits.",
"Bedwetting (Nocturnal Enuresis) – Night-time urine leakage after age 5."
]
},

{
title:"Symptoms in Children",
content:"Children with urinary or genital problems may show certain warning signs. Early consultation with a pediatric urologist helps in timely diagnosis and treatment, preventing long-term complications.",
list:[
"Swelling in scrotum or genital area – May indicate hydrocele, hernia or testicular problem.",
"Pain during urination – Burning or discomfort due to infection or urinary blockage.",
"Poor urine flow – Difficulty in passing urine due to structural problems like phimosis or blockage.",
"Urinary infection – Repeated fever, burning urine or foul-smelling urine.",
"Bedwetting after age 5 – Loss of bladder control during sleep requiring evaluation.",
"Abdominal or flank pain – Pain due to kidney or urinary tract problems.",
"Undescended testis – Testis not present in scrotum after birth.",
"Abnormal urine opening – Seen in conditions like hypospadias."
]
},

{
title:"Advanced Pediatric Urology Procedures",
content:"At BBMH Hospital Bhilwara, modern and safe pediatric urology procedures are performed to treat urinary and genital problems in children with faster recovery and better results.",
list:[
"Stapler circumcision – Quick and painless treatment for phimosis.",
"Hypospadias correction (TIP surgery) – Surgery to correct abnormal urine opening.",
"Undescended testis (UDT) correction – Minor surgery to place testis in proper position.",
"VUR correction – Treatment to stop backward urine flow and prevent infections.",
"Pyeloplasty for PUJO – Surgery to remove kidney urine blockage and swelling.",
"Minimally invasive surgery – Advanced techniques with less pain and quick recovery.",
"Endoscopic procedures – Modern camera-based treatments without large cuts."
]
},

{
title:"Circumcision (Stapler Surgery)",
content:"Stapler circumcision is a modern and painless procedure used to treat phimosis and foreskin problems in children. It is quick, safe, with minimal bleeding and faster recovery compared to traditional circumcision.",
image: ImgCircum
},

{
title:"Hypospadias & UDT Correction",
content:"Hypospadias is a condition where urine opening is not at normal position. TIP surgery is performed to correct this condition. Undescended testis (UDT) is treated with minor surgery to place testis in proper position, ensuring normal growth and fertility in future.",
image: ImgHypo
},

{
title:"PUJO & VUR Treatment",
content:"Pelviureteric Junction Obstruction (PUJO) causes kidney swelling due to urine blockage. Pyeloplasty surgery corrects this blockage. Vesicoureteric reflux (VUR) causes backward flow of urine and repeated infections. Advanced surgical correction ensures proper urine flow and prevents kidney damage.",
image: [ImgPUJO, ImgVUR],
},

{
title:"Why Choose Dr. Sachitanand Chaurasia for Pediatric Urology?",
content:"Dr. Sachitanand Chaurasia is an experienced urologist providing specialized pediatric urology treatment at BBMH (Brijesh Banger Memorial Hospital), Bhilwara. With modern surgical techniques, child-friendly environment and advanced diagnostic facilities, children receive safe and effective treatment with excellent outcomes."
}

],

faq:[
{
q:"Is circumcision safe for children?",
a:"Yes, stapler circumcision is a safe and painless procedure with quick recovery."
},
{
q:"When should undescended testis be treated?",
a:"UDT should be corrected early (usually before 1-2 years age) for best results."
},
{
q:"Is hypospadias curable?",
a:"Yes, hypospadias can be successfully corrected with advanced surgery."
}
]
};

return <TreatmentFullLayout data={data}/>
};

export default PediatricUrology;
